/**
 * Maestro Add-ons Studio UI state.
 *
 * Holds the resolved Studio access, the lists (drafts/published/reviews) and the
 * shared catalogs (connectors/capabilities/templates/componentRegistry) used by the
 * guided builder. The active draft being edited lives here so autosave and the
 * summary panel stay in sync.
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  access: null,
  loadingAccess: false,
  drafts: [],
  published: [],
  reviews: [],
  catalogs: {
    connectors: [],
    capabilities: [],
    templates: [],
    componentRegistry: [],
    partners: [],
  },
  activeDraft: null,
  saving: false,
  lastSavedAt: null,
};

const maestroAddonsSlice = createSlice({
  name: 'maestroAddons',
  initialState,
  reducers: {
    setLoadingAccess: (state, action) => {
      state.loadingAccess = action.payload;
    },
    setAccess: (state, action) => {
      state.access = action.payload || null;
      state.loadingAccess = false;
    },
    setDrafts: (state, action) => {
      state.drafts = action.payload || [];
    },
    setPublished: (state, action) => {
      state.published = action.payload || [];
    },
    setReviews: (state, action) => {
      state.reviews = action.payload || [];
    },
    setCatalog: (state, action) => {
      const { key, items } = action.payload;
      if (key in state.catalogs) state.catalogs[key] = items || [];
    },
    setActiveDraft: (state, action) => {
      state.activeDraft = action.payload || null;
    },
    patchActiveDraft: (state, action) => {
      if (!state.activeDraft) return;
      state.activeDraft = { ...state.activeDraft, ...action.payload };
    },
    setSaving: (state, action) => {
      state.saving = action.payload;
    },
    setLastSavedAt: (state, action) => {
      state.lastSavedAt = action.payload;
    },
    resetMaestroAddons: () => initialState,
  },
});

export const {
  setLoadingAccess,
  setAccess,
  setDrafts,
  setPublished,
  setReviews,
  setCatalog,
  setActiveDraft,
  patchActiveDraft,
  setSaving,
  setLastSavedAt,
  resetMaestroAddons,
} = maestroAddonsSlice.actions;

export default maestroAddonsSlice.reducer;
